import React from 'react';
import { connect } from 'react-redux';
import {
  updateProps as updatePropsAction,
  createDraft as createDraftAction,
  getLocationsAndProducts as getLocationsAndProductsAction,
} from '../../../../../stores/contracting/template-list/template-list-actions';
import RaisedButton from '../../../../tc-ui/raised-button-with-loader';
import CreateTemplateDraft from './create-draft-form';
import moment from 'moment';
import R from 'ramda';
const propTypes = {
  creatingDraft: React.PropTypes.bool,
  updateProps: React.PropTypes.func,
  createDraft: React.PropTypes.func,
  getLocationsAndProducts: React.PropTypes.func,
  createDraftError: React.PropTypes.string,
  locations: React.PropTypes.array,
  startDate: React.PropTypes.string,
  endDate: React.PropTypes.string,
  templateName: React.PropTypes.string,
  style: React.PropTypes.object,
  prefillData: React.PropTypes.object,
  getTemplates: React.PropTypes.func,
  draftRateType: React.PropTypes.string,
  draftCommissionPercentage: React.PropTypes.number,
  draftNettCommission: React.PropTypes.number,
};
class CreateTemplateDraftFormAndButtons extends React.Component {
  componentWillMount() {
    const { prefillData, updateProps, getLocationsAndProducts } = this.props;
    const { startDate, endDate, locationId } = prefillData || {};
    updateProps({
      newDraftStartDate: startDate || undefined,
      newDraftEndDate: endDate || undefined,
      newDraftName: (() => {
        if (startDate && endDate) {
          const startFormatted = moment.utc(startDate).format('DD MMM YYYY');
          const endFormatted = moment.utc(endDate).format('DD MMM YYYY');
          if (startFormatted === endFormatted) return `${startFormatted} Rates Template`;
          return `${startFormatted} - ${endFormatted} Rates Template`;
        }
        return 'Rates Template';
      })(),
    });
    getLocationsAndProducts(locationId);
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  createDraft = () => {
    const {
      startDate,
      endDate,
      locations,
      templateName,
      updateProps,
      createDraft,
      draftRateType,
      draftCommissionPercentage,
      draftNettCommission,
      copyDataFromTemplate,
    } = this.props;
    const updatedContactInfoComplete = contactInfo => (
    contactInfo.address
    && (
      contactInfo.address.address_1
      || contactInfo.formattedAddress
    )
    && contactInfo.phone
    && contactInfo.firstName
    && contactInfo.lastName);
    const locationsValid = locations.filter(R.propEq('checked', true)).every(loc => loc.contactInfoComplete || updatedContactInfoComplete(loc.contactInfo));
    const dataValid = R.call(R.allPass([
      () => startDate,
      () => endDate,
      () => R.any(R.propEq('checked', true), locations),
      () => templateName,
      () => locationsValid,
    ]));
    if (dataValid) {
      createDraft({
        startDate,
        endDate,
        locations,
        templateName,
        draftRateType,
        draftCommissionPercentage,
        draftNettCommission,
        copyDataFromTemplate,
      })
      .then(res => {
        const draftsLength = R.pathOr(0, ['payload', 'drafts', 'length'], res);
        const firstDraft = R.pathOr({}, ['payload', 'drafts', 0], res);
        if (draftsLength > 1) this.context.router.replace('/contracting/template-list');
        if (draftsLength === 1) this.context.router.replace(`/contracting/draft/${firstDraft.originalContractId}/details`);
      });
    }
    else updateProps({ createDraftError: 'Please fill all required fields' });
  };
  render() {
    const {
      creatingDraft,
      updateProps,
      createDraftError,
      locations,
      style,
      prefillData,
      copyDataFromTemplate,
    } = this.props;
    return (
      <div style={style}>
        <CreateTemplateDraft
          updateProps={updateProps}
          hideDates={Boolean(prefillData && prefillData.startDate && prefillData.endDate)}
        />
        <RaisedButton
          data-cy="createTemplateDraftButton"
          style={{ marginTop: '24px' }}
          label="start"
          disabled={!R.any(R.propEq('checked', true), locations)}
          loader={creatingDraft}
          secondary
          onTouchTap={this.createDraft}
        />
        <span style={{ color: 'red', paddingLeft: '16px' }}>{createDraftError}</span>
      </div>
    );
  }
}

CreateTemplateDraftFormAndButtons.propTypes = propTypes;
CreateTemplateDraftFormAndButtons.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
const mapStateToProps = ({ contracting }) => ({
  createDraftError: contracting.templateList.get('createDraftError'),
  locations: contracting.templateList.get('locations').toJS(),
  startDate: contracting.templateList.get('newDraftStartDate'),
  endDate: contracting.templateList.get('newDraftEndDate'),
  templateName: contracting.templateList.get('newDraftName'),
  draftRateType: contracting.templateList.get('draftRateType'),
  draftCommissionPercentage: contracting.templateList.get('draftCommissionPercentage'),
  draftNettCommission: contracting.templateList.get('draftNettCommission'),
});
const mapDispatchToProps = dispatch => ({
  updateProps: payload => dispatch(updatePropsAction(payload)),
  createDraft: (...args) => dispatch(createDraftAction(...args)),
  getLocationsAndProducts: (...args) => dispatch(getLocationsAndProductsAction(...args)),
});
CreateTemplateDraftFormAndButtons.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateTemplateDraftFormAndButtons);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-template-draft/components/formWithButtons.jsx